document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-olympiad-registration-notice]').forEach((dialog) => {
    const openButtons = document.querySelectorAll('[data-olympiad-registration-notice-open]');
    const closeButtons = dialog.querySelectorAll('[data-olympiad-registration-notice-close]');
    const title = dialog.querySelector('#olympiad-registration-notice-title');
    const text = dialog.querySelector('#olympiad-registration-notice-text');

    if (!openButtons.length || !title || !text || typeof dialog.showModal !== 'function') {
      return;
    }

    const defaultTitle = title.textContent.trim();
    const defaultText = text.textContent.trim();

    const closeDialog = () => {
      if (dialog.open) {
        dialog.close();
      }
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        title.textContent = button.dataset.olympiadRegistrationNoticeHeading || defaultTitle;
        text.textContent = button.dataset.olympiadRegistrationNoticeMessage || defaultText;

        if (!dialog.open) {
          dialog.showModal();
        }
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeDialog);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeDialog();
      }
    });
  });
});
